import React from 'react';
import { SOCIAL_LINKS } from '../../data/links';
const SOCIALS = [{
  label: 'Instagram',
  href: SOCIAL_LINKS.instagram
}, {
  label: 'Facebook',
  href: SOCIAL_LINKS.facebook
}, {
  label: 'TikTok',
  href: SOCIAL_LINKS.tiktok
}];
export function SiteFooter() {
  return <footer className="border-t border-white/10 bg-[#08090b] px-5 py-10 pb-24 sm:px-8 lg:px-12 lg:pb-10" data-id="element-70" data-mp="1j8pqgdg47q8h">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-71" data-mp="2gw7wvhmb0g9b">
        <div data-id="element-72" data-mp="2bwvd55qqbpay">
          <div className="flex items-baseline gap-1.5" data-id="element-73" data-mp="2byer2powxo9k">
            <span className="font-display text-lg font-bold uppercase tracking-[0.18em] text-white" data-id="element-74" data-mp="26ya9ewc9qnhr">
              VCARS
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-[#3b6bff]" data-id="element-75" data-mp="22vndaj8keger" />
          </div>
          <p className="mt-2 text-sm text-white/45" data-id="element-76" data-mp="vjmzug3i6n1u">
            Compra, cambio y asesoramiento automotriz. Atención por WhatsApp.
          </p>
        </div>

        <nav className="flex gap-5 text-sm text-white/60" data-id="element-77" data-mp="rjmlswkbgdvb">
          {SOCIALS.map(social => <a key={social.label} href={social.href} target="_blank" rel="noopener noreferrer" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-78" data-mp="3l7qvvdcxs3df">
              {social.label}
            </a>)}
        </nav>
      </div>
    </footer>;
}